import React from 'react';
import UlbForm from './UlbForm'
import { connect } from 'react-redux';
import * as actionsCreators from  '../../store/actions/index';
function UlbAdd(props) {
    const handleSubmit = (formdata, SubmitProp, token)=>{
        props.onAddUlbData(formdata,SubmitProp, props)

    }
    return (
        <div>
           <div className="create_ulb">
            <div className="dashboard_top_path">
                <p><img src="images/left-arrow.svg" alt='ulb' /> ULB Management / <span>Create New ULB</span></p>
            </div>
            <div className="dashboard_right_content">
                <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                <div className="dashboard_right_content_top">
                    <h5>Create New ULB</h5>
                </div>
                <div className="create_ulb_content_outer">
                    <div className="create_ulb_content">
                        
                       <UlbForm handleSubmit={handleSubmit}/>
                       
                    </div>
                </div>
            </div>
        </div> 
        </div>
    );
}

const mapStateToProps = (state,props) => {
    return {
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onAddUlbData :(formdata,SubmitProp, props)=>dispatch(actionsCreators.addUlbData(formdata,SubmitProp,props))
    }
}
export default  connect(mapStateToProps, mapDispatchToProps)(UlbAdd);